export default __webpack_public_path__ + "static/media/SettlementOff.50ad4086.svg";